import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfTransBaseLang',
  standalone: false,
})
export class TypeOfTransBaseLangPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.TRANS_BASE_LANG_JA:
        type = this.translate.instant('日本語');
        break;
      case AppConst.TRANS_BASE_LANG_US:
        type = this.translate.instant('英語（アメリカ）');
        break;
      case AppConst.TRANS_BASE_LANG_EN:
      default:
        type = this.translate.instant('英語（イギリス）');
        break;
    }
    return type;
  }
}
